import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { fetch_payout_deleted_teacher } from '../../teacher_payments/api';
import {
  DELETED_ACCOUNTS_LINK,
  can_see_deleted_accounts,
  deleted_teacher_banner
} from '../../teacher_payments/payouts/deleted_alert';

// PROD-7828 D10: a deleted account with money due, on the teacher profile. Read only for the payouts roles (anyone
// else would get a 403); a failed read shows nothing, the Teacher Payments page banner is the backstop.
const STYLE = {
  background: 'var(--state-error-bg)',
  border: '1px solid var(--state-error)',
  color: 'var(--state-error-text)',
  borderRadius: 7,
  padding: '9px 13px',
  fontSize: 13,
  margin: '12px 0'
};

const DeletedMoneyDueBanner = ({ teacher_uuid, access_type }) => {
  const [text, setText] = useState(null);
  const allowed = can_see_deleted_accounts(access_type);
  useEffect(() => {
    setText(null);
    if (!teacher_uuid || !allowed) return undefined;
    let cancelled = false;
    fetch_payout_deleted_teacher(teacher_uuid)
      .then((data) => {
        if (!cancelled) setText(deleted_teacher_banner(data));
      })
      .catch(() => {
        if (!cancelled) setText(null);
      });
    return () => {
      cancelled = true;
    };
  }, [teacher_uuid, allowed]);

  if (!text) return null;
  return (
    <div style={STYLE} role="alert">
      {text} – <Link to={DELETED_ACCOUNTS_LINK}>Review in Bank payouts</Link>
    </div>
  );
};

export default DeletedMoneyDueBanner;
